import React, { Component } from 'react'
import { Section, Input, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class ExtensionTime extends Component {
  render() {
    const {
      formData,
      editRoleDetail,
      isErrExtensionMinutes,
      isSetState,
    } = this.props
    return (
      <Section className="form-group">
        <label className="extension-time">
          Extension Time <br />
          (Minutes)
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <Checkbox
              id="no_extensiontime"
              value="no_extensiontime"
              type="radio"
              name="no_extensiontime"
              checked={!formData.step2.eventInformation.is_ExtensionTime}
              className="inline"
              onChange={e => {
                formData.step2.eventInformation.is_ExtensionTime = false
                formData.step2.eventInformation.eventExtensionMinutes = ''
                formData.step2.eventInformation.eventExtensionTime = ''
                isSetState({
                  formData,
                  isErrDisplayDummy: false,
                  isErrExtensionMinutes: false,
                  isErrMaxExtensionTime: false,
                })
              }}
              disabled={!editRoleDetail ? true : false}
            >
              <div className="extension-time" style={{ width: '105px' }}>
                No
              </div>
            </Checkbox>

            <Section style={{ justifyContent: 'space-between' }}>
              <Checkbox
                id="yes_extensiontime"
                value="yes_extensiontime"
                type="radio"
                name="yes_extensiontime"
                checked={formData.step2.eventInformation.is_ExtensionTime}
                className="inline"
                onChange={e => {
                  formData.step2.eventInformation.is_ExtensionTime = true
                  formData.step2.eventInformation.is_MaxExtension = true
                  isSetState({
                    formData,
                  })
                }}
                disabled={!editRoleDetail ? true : false}
              >
                <div className="extension-time">Yes</div>
              </Checkbox>

              {/* input Extension Time  */}
              <Section
                className={`form-group ${isErrExtensionMinutes && 'is-error'}`}
                style={{ width: '60%' }}
              >
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <NumberFormat
                      className="minutes"
                      placeholder="Minutes"
                      isAllowed={inputObj => {
                        const { value } = inputObj
                        if (value !== '-') return true
                        return false
                      }}
                      value={
                        formData.step2.eventInformation.eventExtensionMinutes
                          ? formData.step2.eventInformation
                              .eventExtensionMinutes
                          : ''
                      }
                      maxLength={11}
                      customInput={Input}
                      decimalScale={0}
                      onValueChange={e => {
                        if (e.floatValue <= 0) {
                          formData.step2.eventInformation.eventExtensionMinutes = null
                        } else {
                          formData.step2.eventInformation.eventExtensionMinutes =
                            e.floatValue
                        }
                        isSetState({
                          formData,
                          isErrExtensionMinutes: false,
                        })
                      }}
                      thousandSeparator={true}
                      readOnly={
                        !formData.step2.eventInformation.is_ExtensionTime ||
                        !editRoleDetail
                      }
                    />
                  </Section>
                  {isErrExtensionMinutes && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="message">{STRING.INVALID}</Section>
        </Section>
      </Section>
    )
  }
}
